
export const BREAKPOINTS = {
    pc: 960
};

export const EVENT_CODE = '200122_preorder';

export const TRACKING = {
    PC_PREORDER_BUTTON_CLICK:
        'https://i23.icast-ad.com/track?ccd=4223&mcd=01040601&pcd=11308',
    MOBILE_PREORDER_BUTTON_CLICK:
        'https://i23.icast-ad.com/track?ccd=4223&mcd=01040601&pcd=11309'
};

const Config = {
    movieModal: {
        baseUrl: 'https://www.youtube.com/embed/',
        options: {
            type: 'youtube',
            isEsc: true,
            movieParams: '?vq=hd720&autoplay=0&version=3&rel=0',
            isAutoButton: true
        }
    }
};

export default Config;
